import React, { Component } from 'react';

export class Alert extends Component {
  constructor(props) {
    super(props);

    const { type, isOpen = true } = this.props;

    this.state = {
      type,
      isOpen
    };
  }

  static getDerivedStateFromProps({ isOpen, type }) {
    return { type, isOpen };
  }

  componentDidMount() {
    window.scrollTo(0, 0);
  }

  closeAlert = () => {
    const { onCloseAlert } = this.props;
    this.setState({
      isOpen: false
    });
    onCloseAlert();
  };

  render() {
    const { isOpen, type } = this.state;
    const { children } = this.props;
    return (
      isOpen && (
        <div className={`alert ${type}`}>
          {children}

          <span
            role="button"
            tabIndex="0"
            onKeyPress={this.closeAlert}
            onClick={this.closeAlert}
            href="#"
            title="Fechar"
            aria-label="Fechar"
            className="close"
          />
        </div>
      )
    );
  }
}
export default Alert;
